import { createApi } from '@reduxjs/toolkit/query/react';
import {
  getOnboarding,
  updateOnboarding,
  simulateTestPayment,
} from '../onboarding/onboardingClient';

// Scope the mock store to the signed-in account. Falls back to email, then anon.
const userIdFromState = (getState) => {
  const user = getState().auth?.user;
  return user?.id ?? user?.userId ?? user?.email ?? 'anon';
};

/**
 * onboardingApi
 * Thin RTK Query wrapper over the typed onboarding client so the wizard gets
 * caching, resume, and automatic refetch via the existing data layer.
 *
 * TODO(backend): swap the `queryFn`s for real endpoints once `/onboarding`
 * exists. The client module (onboardingClient.js) is the single seam to change.
 */
export const onboardingApi = createApi({
  reducerPath: 'onboardingApi',
  baseQuery: () => ({ data: undefined }), // unused; every endpoint uses queryFn
  tagTypes: ['Onboarding'],
  endpoints: (builder) => ({
    getOnboarding: builder.query({
      queryFn: async (_arg, { getState }) => {
        try {
          const data = await getOnboarding(userIdFromState(getState));
          return { data };
        } catch (error) {
          return { error: { message: error.message } };
        }
      },
      providesTags: ['Onboarding'],
    }),

    updateOnboarding: builder.mutation({
      queryFn: async (patch, { getState }) => {
        try {
          const data = await updateOnboarding(userIdFromState(getState), patch);
          return { data };
        } catch (error) {
          return { error: { message: error.message } };
        }
      },
      invalidatesTags: ['Onboarding'],
    }),

    simulateTestPayment: builder.mutation({
      queryFn: async (_arg, { getState }) => {
        try {
          const data = await simulateTestPayment(userIdFromState(getState));
          return { data };
        } catch (error) {
          return { error: { message: error.message } };
        }
      },
      invalidatesTags: ['Onboarding'],
    }),
  }),
});

export const {
  useGetOnboardingQuery,
  useUpdateOnboardingMutation,
  useSimulateTestPaymentMutation,
} = onboardingApi;
